import * as React from "react";
function SvgTabClose(props) {
  return <svg width="1em" height="1em" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M.806.105a.5.5 0 00-.66.749L3.293 4 .146 7.146a.5.5 0 00.66.75l.048-.042L4 4.707l3.146 3.147.048.041a.5.5 0 00.66-.749L4.707 4 7.854.854a.5.5 0 00-.66-.75l-.048.042L4 3.293.854.146.806.105z" fill="currentColor" /></svg>;
}
export default SvgTabClose;